import React from 'react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import useCustomFetch from '../../../../hooks/useFetchContent'
import {brandInfoStyles} from './index.style'

function BrandInfo({category}) {
    const {token} = useAccessToken()
    const {response} = useCustomFetch(token, [
        `dynamiccategorylanding-content:category:${category?.id}`,
        `dynamiccategorylanding-promotion:category:${category?.id}`,
        `dynamiccategorylanding-checkerboard:category:${category?.id}`
    ])

    return <Box sx={brandInfoStyles} dangerouslySetInnerHTML={{__html: response}} />
}

BrandInfo.propTypes = {
    category: PropTypes.object
}

export default BrandInfo
